if (!customElements.get('ema-photo-archive')) {
  customElements.define('ema-photo-archive', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const library = this.querySelector('[data-library]');
      const grid = this.querySelector('[data-grid]');
      const dialog = this.querySelector('dialog');
      const full = this.querySelector('[data-full]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const more = this.querySelector('[data-load-more]');
      const retry = this.querySelector('[data-retry]');
      const status = this.querySelector('[data-library-status]');
      const filters = [...this.querySelectorAll('[data-filter]')];
      const batch = Number(this.dataset.pageSize) || 24;
      let records = [], matching = [], shown = 0, index = 0, category = 'all', opener;
      let nextURL = library.querySelector('[data-library-next]')?.getAttribute('href');
      const visited = new Set();
      library.querySelector('[data-library-next]')?.setAttribute('hidden', '');
      const updateRecords = () => {
        records = [...library.querySelectorAll('template[data-archive-item]')]
          .sort((a, b) => Number(a.dataset.sort || 999999) - Number(b.dataset.sort || 999999));
      };
      const appendBatch = () => {
        const added = matching.slice(shown, shown + batch);
        const fragment = document.createDocumentFragment();
        added.forEach(record => {
          const card = record.content.firstElementChild.cloneNode(true);
          card.dataset.recordId = record.dataset.id;
          card.querySelectorAll('img[data-src]').forEach(img => {
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.src = img.dataset.src;
          });
          fragment.append(card);
        });
        grid.append(fragment);
        shown += added.length;
        more.hidden = shown >= matching.length;
        this.querySelector('[data-count]').textContent = `${shown} of ${matching.length} photos`;
        this.querySelector('[data-empty]').hidden = matching.length !== 0;
      };
      const render = () => {
        matching = records.filter(record => category === 'all' || record.dataset.category === category);
        grid.replaceChildren();
        shown = 0;
        appendBatch();
      };
      const show = value => {
        if (!matching.length) return;
        index = (value + matching.length) % matching.length;
        const link = matching[index].content.querySelector('[data-photo]');
        full.src = link.href;
        full.alt = link.querySelector('img').alt;
        this.querySelector('[data-description]').textContent = link.dataset.caption;
        this.querySelector('[data-position]').textContent = `${index + 1} / ${matching.length}`;
        prev.disabled = next.disabled = matching.length < 2;
      };
      const loadLibrary = async () => {
        filters.forEach(button => { button.disabled = true; });
        more.disabled = true;
        retry.hidden = true;
        status.textContent = nextURL ? 'Loading photo library…' : '';
        try {
          while (nextURL) {
            const url = new URL(nextURL, window.location.href);
            if (url.origin !== window.location.origin) throw new Error('Unexpected library URL');
            url.searchParams.set('section_id', this.dataset.sectionId);
            if (visited.has(url.href)) throw new Error('Repeated library page');
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Unable to load library');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = [...doc.querySelectorAll('ema-photo-archive')].find(root => root.dataset.sectionId === this.dataset.sectionId);
            if (!incoming) throw new Error('Missing library section');
            const ids = new Set([...library.querySelectorAll('[data-id]')].map(item => item.dataset.id));
            incoming.querySelectorAll('template[data-archive-item]').forEach(item => {
              if (!ids.has(item.dataset.id)) { library.append(item); ids.add(item.dataset.id); }
            });
            visited.add(url.href);
            nextURL = incoming.querySelector('[data-library-next]')?.getAttribute('href');
          }
          updateRecords();
          render();
          status.textContent = '';
          filters.forEach(button => { button.disabled = false; });
          more.disabled = false;
        } catch (error) {
          status.textContent = 'Some archive entries could not be loaded. Please retry to browse the complete library.';
          retry.hidden = false;
        }
      };
      this.querySelector('[data-toolbar]').hidden = false;
      updateRecords();
      render();
      loadLibrary();
      retry.addEventListener('click', loadLibrary);
      filters.forEach(button => button.addEventListener('click', () => {
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        category = button.dataset.filter;
        render();
      }));
      more.addEventListener('click', () => {
        const previousCount = shown;
        appendBatch();
        grid.children[previousCount]?.querySelector('a')?.focus();
      });
      grid.addEventListener('click', event => {
        const link = event.target.closest('[data-photo]');
        if (!link || !dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        show(matching.findIndex(record => record.dataset.id === link.closest('[data-record-id]').dataset.recordId));
        dialog.showModal();
      });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => opener?.focus());
      prev.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
    }
  });
}
